import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import ComboBox from "../../shared/components/ComboBox";
import { users } from "../actions";
import selectors from "../selectors";

const sortOptions = [
  { label: "Groups", key: "group" },
  { label: "Users", key: "user" },
  { label: "Name", key: "name" },
  { label: "Domain", key: "domain" }
];

class PoliciesTableFilter extends Component {
  constructor(props) {
    super(props);
    const { filterTerm } = props;
    this.state = { value: filterTerm };
  }

  static getDerivedStateFromProps = (props, state) => {
    if (props.filterTerm !== state.value) {
      return { value: props.filterTerm };
    }
    return null;
  };

  handleChange = e => {
    const { setFilterTerm } = this.props;
    const filterTerm = e.target.value.toLowerCase();

    this.setState({ value: e.target.value });
    setFilterTerm(filterTerm);
  };

  resetFilter = () => {
    const { setFilterTerm } = this.props;

    this.setState({ value: "" });
    setFilterTerm("");
  };

  render() {
    const { value } = this.state;
    const { setSortState, sortBy } = this.props;

    return (
      <ComboBox
        value={value}
        placeholder="Search &amp; Filter"
        onChange={e => this.handleChange(e)}
        onReset={() => this.resetFilter()}
        options={sortOptions}
        selectOption={setSortState}
        selected={sortBy}
      />
    );
  }
}

PoliciesTableFilter.propTypes = {
  setFilterTerm: PropTypes.func.isRequired,
  filterTerm: PropTypes.string.isRequired,
  setSortState: PropTypes.func.isRequired,
  sortBy: PropTypes.string
};

PoliciesTableFilter.defaultProps = {
  sortBy: undefined
};

const mapStateToProps = state => ({
  filterTerm: selectors.users.getFilterTerm(state)
});

const mapDispatchToProps = {
  setFilterTerm: users.setFilterTerm
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PoliciesTableFilter);
